import { Controller } from '@hotwired/stimulus'
import { toggleClass } from 'utils/toggle_class'

export default class extends Controller {
  static targets = ["mobileNav", "button"]

  toggleOpen(event) {
    event.preventDefault()

    // Apply a class so we can style the button
    toggleClass(this.buttonTarget, '-open-mobile-menu')

    // Apply a class to the mobile nav menu, so we can show it correctly.
    // For logged in this applies to the sidebar
    toggleClass(this.mobileNavTarget, '-open-mobile-menu')
  }
}
